import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Signphoto from "../../assets/images/logo.png";
import { gsap } from "gsap";
import { FaUser, FaEnvelope, FaLock } from 'react-icons/fa'; 
import './Signup.css';

const SignUp = () => {
  const navigate = useNavigate();
  const [clientName, setClientName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [checked, setChecked] = useState(false);

  const [errClientName, setErrClientName] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    // Animate the left section 
    gsap.fromTo(
      ".left-section",
      { opacity: 0, x: -50 }, 
      { opacity: 1, x: 0, duration: 1, ease: "power2.out" } 
    );
  }, []);

  const handleSignUp = (e) => {
    e.preventDefault();
    if (checked) {
      if (!clientName) {
        setErrClientName("Enter your name");
      }
      if (!email) {
        setErrEmail("Enter your email");
      }
      if (!password) {
        setErrPassword("Create a password");
      } else {
        if (password.length < 6) {
          setErrPassword("Passwords must be at least 6 characters");
        }
      }

      if (clientName && email && password && password.length >= 6) {
        const data = {
          clientName,
          email,
          password,
        };
        localStorage.setItem("user", JSON.stringify(data));
        setClientName("");
        setEmail("");
        setPassword("");

        navigate("/signin");
      }
    }
  };

  return (
    <div
    className="w-full h-screen flex items-center justify-center"
    style={{ backgroundColor: "#fdfaf4" }} // Bright sand cream background
  >
    {/* Left Section */}
    <div className="w-1/3 hidden lgl:inline-flex h-full text-white relative left-section">
      <div
        className="w-[550px] h-full px-10 flex flex-col items-center justify-center relative"
        style={{ backgroundColor: "#E6C78A" }} // Earthy brown for left section
      >
        <div
          className="w-[350px] h-[450px] flex justify-center items-center rounded-3xl mb-6 relative moving-section"
          style={{
            backgroundColor: "#46A29F", // Luxurious gold for highlight box // Rich shadow for depth
          }}
        >
          <div className="absolute top-20 left-70 bottom-auto flex flex-col items-center justify-center text-center z-0">
            <h1
              className="font-titleFont text-5xl font-medium ml-80 mb-2 opacity-95"
              style={{
                color: "white", // Pharaonic teal for mystical feel
                textShadow: "4px 6px 10px rgba(0, 0, 0, 0.4)", // Elegant shadow
              }}
            >
              Unlock The Secrets Of Egypt!
            </h1>
          </div>
          <div className="absolute bottom-0 right-10 flex flex-col items-center justify-center text-center z-0">
            <Link to="/">
              <img
                src={Signphoto}
                alt="logoImg"
                className="w-70 h-70 object-contain z-50"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
    

      {/* Right Section */}
      <div className="w-full lgl:w-1/2 h-full flex items-center justify-center">
        {successMsg ? (
          <div className="w-full lgl:w-[500px] h-full flex flex-col justify-center">
            <p className="w-full px-4 py-10 text-green-500 font-medium font-titleFont">
              {successMsg}
            </p>
            <Link to="/signin">
              <button className="w-full h-10 bg-primeColor text-gray-200 rounded-md text-base font-titleFont font-semibold tracking-wide hover:bg-black hover:text-white duration-300">
                Sign in
              </button>
            </Link>
          </div>
        ) : (
          <form className="w-full lgl:w-[450px] h-screen flex items-center justify-center">
            <div className="px-6 py-4 w-full h-[90%] flex flex-col justify-center overflow-y-scroll scrollbar-thin scrollbar-thumb-primeColor">
              <h1 className="font-titleFont decoration-[1px] font-semibold text-3xl mdl:text-4xl mb-4 ml-36" style={{ fontFamily: 'Poppins, sans-serif' }}>
                SIGN UP
              </h1>

              <div className="flex flex-col gap-3">
                {/* Client Name */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-black">Full Name</p>
                  <div className="relative">
            
                    <FaUser
  className="absolute left-3 top-1/2 transform -translate-y-1/2"
  style={{ color: '#46A29F' }}
/>
                    <input
                      onChange={(e) => setClientName(e.target.value)}
                      value={clientName}
                      className="w-full h-8 pl-10 placeholder-black placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] outline-none"
                      style={{ backgroundColor: '#e4d1aee0', color: 'black' }}
                      type="text"
                      placeholder="Firstname Lastname"
                    />
                  </div>
                  {errClientName && <p className="text-sm text-red-500 font-titleFont font-semibold px-4"><span className="font-bold italic mr-1">!</span>{errClientName}</p>}
                </div>

                {/* Email */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-black" >Email</p>
                  <div className="relative">
                    <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black"  style={{ color: '#46A29F' }}/>
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      className="w-full h-8 pl-10 placeholder-black placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] outline-none"
                      style={{ backgroundColor: '#e4d1aee0', color: 'black' }}
                      type="email"
                      placeholder="user@gmail.com"
                    />
                  </div>
                  {errEmail && <p className="text-sm text-red-500 font-titleFont font-semibold px-4"><span className="font-bold italic mr-1">!</span>{errEmail}</p>}
                </div>

                {/* Password */}
                <div className="flex flex-col gap-.5">
                  <p className="font-titleFont text-base font-semibold text-black">Password</p>
                  <div className="relative">
                    <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black"  style={{ color: '#46A29F' }}/>
                    <input
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      className="w-full h-8 pl-10 placeholder-black placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] outline-none"
                      style={{ backgroundColor: '#e4d1aee0', color: 'black' }}
                      type="password"
                      placeholder="Create password"
                    />
                  </div>
                  {errPassword && <p className="text-sm text-red-500 font-titleFont font-semibold px-4"><span className="font-bold italic mr-1">!</span>{errPassword}</p>}
                </div>

                {/* Checkbox */}
                <div className="flex items-start mdl:items-center gap-2">
      <input
        onChange={() => setChecked(!checked)}
        className="w-0 h-0 opacity-0"
        type="checkbox"
        id="terms-checkbox"
      />
      <label
        htmlFor="terms-checkbox"
        className="w-4 h-4 cursor-pointer custom-checkbox"
      />
      <p className="text-sm text-primeColor">
        I agree to the{" "}
        <span style={{ color: "#437e9c" }}>Terms of Service</span> and{" "}
        <span style={{ color: "#437e9c" }}>Privacy Policy</span>
      </p>
    </div>


                {/* Submit Button */}
                <button onClick={handleSignUp} className="bg-gradient-to-r from-[#A79277] to-[#E6C78A] hover:bg-black text-white hover:text-white cursor-pointer w-full text-base font-medium h-10 rounded-md duration-300">
                  Create Account
                </button>

                <p className="text-sm text-center font-titleFont font-medium">
                  Already have an Account?{" "}
                  <Link to="/signin">
                    <span className="text-black hover:text-transparent hover:bg-gradient-to-r hover:from-[#A79277] hover:to-[#5F4C34] bg-clip-text cursor-pointer duration-300">
                      Sign in
                    </span>
                  </Link>
                </p>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SignUp;